import { useEffect } from 'react';

declare global {
    interface Window {
        adsbygoogle: any[];
    }
}

const Ads = () => {
    useEffect(() => {
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (error) {
            console.error('AdSense error:', error);
        }
    }, []);

    return (
        <div className="w-full h-32 bg-theme-inputbg flex items-center justify-center text-theme-muted">
            <ins 
                className="adsbygoogle"
                style={{ display: 'block' }}
                data-ad-client="ca-pub-2395804059090413"
                data-ad-slot="9175138668"
                data-ad-format="auto"
                data-full-width-responsive="true"
            />
        </div>
    );
}

export default Ads;